import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ca28a92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Back to Units")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Unit", -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Size", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Plans", -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Reservation Price", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Gate Key", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Rented to", -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Billing Cycle", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Next Bill", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Status", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" to ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Damaged")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Rentable", -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode("No")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Yes")
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Description", -1))
const _hoisted_26 = { key: 3 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Size", -1))
const _hoisted_28 = { key: 4 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Access Instructions", -1))
const _hoisted_30 = { key: 5 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Combination Lock Number", -1))
const _hoisted_32 = {
  key: 1,
  class: "customer-select"
}
const _hoisted_33 = ["value"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Rent to Customer ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Reserve for Customer")
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn" }, "Rent to Customer", -1))
const _hoisted_39 = {
  key: 0,
  class: "btn"
}
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Rent to New Customer ")
const _hoisted_41 = { key: 2 }

import { computed, ref } from "vue";

import api from "@virgodev/bazaar/functions/api";
import { CustomerDataInterface } from "@/types/customers";
// const router = useRouter();
import UnitRentableModal from "../../components/UnitRentableModal.vue";
import BaseSpinner from "../../components/BaseSpinner.vue";
import { storeToRefs } from "pinia";
import { useStore } from "../../store";

export default /*#__PURE__*/_defineComponent({
  props: {
  id: {
    type: String,
    required: true,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

// import { useRouter } from "vue-router";
const store = useStore();
const { userData } = storeToRefs(store);
const api_settings = userData.value.chosenFacility.api_settings;
const isCubbyFacility = computed(() =>
  userData.value.chosenFacility.api_name?.toLowerCase().includes("cubby")
);
const editKey = ref(false);
const submittingKey = ref(false);
const newGateKey = ref();
const unitStatusChange = ref(false);
const status = ref("loading");
const selectedReservation = ref();
const unit = ref();
const errors = ref("");
const customer = ref();
const customers = ref(Array<CustomerDataInterface>());
const chosenCustomer = ref(null);


async function getUnit() {
  errors.value = "";
  try {
    const response = await api({
      url: `units/?id=${props.id}&facilityId=${props.facilityId}`,
    });
    if (response.status == 200) {
      unit.value = response.body[0];
      unit.value.status = unit.value.status.toLowerCase();
      const vacant =
        unit.value.status === "available" || unit.value.status === "vacant";
      if (unit.value.current_tenant_id && !vacant) {
        await getCustomer();
        if (api_settings.ledger_id_unit_detail) {
          await getLedgers(unit.value.current_ledger_id);
        } else {
          await getLedgers(unit.value.current_tenant_id);
        }
      } else {
        await getCustomers();
      }
      if (unit.value.status == "reserved") {
        await getLead();
      }
      await getUnitTypes(unit.value.unit_group_id);
      status.value = "loaded";
    } else {
      errors.value =
        "Unable to communicate with the server. Please check your " +
        "connection and try again.";
      status.value = "error";
    }
  } catch {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
    status.value = "error";
  }
}
async function getLead() {
  errors.value = "";

  const response = await api({
    url: `list_reservations/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    let leads = response.body;

    if (response.body.leads) {
      leads = response.body.leads;
    }
    selectedReservation.value = leads.filter(
      (item: { unit: { id: string } }) => item.unit.id == props.id
    )[0];
    if (
      !unit.value.current_tenant_id &&
      selectedReservation.value.customer_id
    ) {
      unit.value.current_tenant_id = selectedReservation.value.customer_id;
      await getCustomer();
      selectedReservation.value.tenant = customer.value;
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function updateKey() {
  errors.value = "";
  submittingKey.value = true;
  const response = await api({
    url: `update_access_code/?id=${unit.value.ledger.id}&facilityId=${props.facilityId}`,
    method: "PATCH",
    json: JSON.parse(
      JSON.stringify({
        gate_access_code: newGateKey.value,
      })
    ),
  });
  if (response.status == 200) {
    editKey.value = false;
    unit.value.ledger.gate_access_code = newGateKey.value;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
  submittingKey.value = false;
}
async function getLedgers(id: string) {
  if (id) {
    errors.value = "";
    const response = await api({
      url: `ledgers/?only_ids=${id}&facilityId=${props.facilityId}`,
    });
    if (response.status == 200) {
      if (api_settings.ledger_id_unit_detail) {
        unit.value.ledger = response.body.ledgers[0];
        newGateKey.value = unit.value.ledger.gate_access_code;
      } else {
        unit.value.ledger = response.body.filter(
          (item: { unit: { id: string } }) => item.unit.id == props.id
        )[0];
      }
    } else {
      errors.value =
        "Unable to communicate with the server. Please check your " +
        "connection and try again.";
    }
  }
}
async function modalClosed() {
  unitStatusChange.value = false;
  await getUnit();
}
async function getCustomers() {
  errors.value = "";
  const response = await api({
    url: `customers/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    const body = response.body;
    customers.value = Array.isArray(body)
      ? body
      : body?.customers || body?.tenants || [];
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getCustomer() {
  errors.value = "";
  const response = await api({
    url: `customers/?id=${unit.value.current_tenant_id}&facilityId=${props.facilityId}&type=customer_id`,
  });
  if (response.status == 200) {
    customer.value = response.body[0];
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

async function getUnitTypes(id: string) {
  errors.value = "";
  const response = await api({
    url: `unit_types/?id=${id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    unit.value.unit_type = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
getUnit();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RouterLink, {
      to: { name: 'units_storedge', params: { facilityId: __props.facilityId } }
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["to"]),
    _hoisted_3,
    (status.value === 'loading')
      ? (_openBlock(), _createBlock(BaseSpinner, {
          key: 0,
          preset: "large"
        }))
      : _createCommentVNode("", true),
    (unit.value && status.value == 'loaded')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("h3", null, "Name / Number: " + _toDisplayString(unit.value.name), 1),
          _createElementVNode("table", null, [
            (unit.value.length && unit.value.width && unit.value.height)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("td", null, [
                    (unit.value.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(unit.value.length), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (unit.value.width)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" x " + _toDisplayString(unit.value.width), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (unit.value.height)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(" x " + _toDisplayString(unit.value.height), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("tr", null, [
              _hoisted_7,
              _createElementVNode("td", null, "$" + _toDisplayString(Number(unit.value.price).toFixed(2)) + " per month", 1)
            ]),
            (unit.value.unit_type && unit.value.unit_type.unit_group)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("td", null, _toDisplayString(unit.value.unit_type.unit_group.reservation_fee), 1)
                ]))
              : _createCommentVNode("", true),
            (
            !['vacant', 'reserved', 'available'].includes(unit.value.status) &&
            unit.value.ledger
          )
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (unit.value.ledger)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                        _hoisted_11,
                        (!editKey.value)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                              _createTextVNode(_toDisplayString(unit.value.ledger.gate_access_code) + " ", 1),
                              (_unref(api_settings).allow_gate_access_update)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (
                      unit.value.ledger.gate_access_code &&
                      unit.value.ledger.gate_access_code.length
                    )
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: "btn btn-blue",
                                          onClick: _cache[0] || (_cache[0] = ($event: any) => (editKey.value = true))
                                        }, " Edit "))
                                      : (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: "btn btn-blue",
                                          onClick: _cache[1] || (_cache[1] = ($event: any) => (editKey.value = true))
                                        }, " Add "))
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("td", _hoisted_13, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newGateKey).value = $event)),
                                type: "text"
                              }, null, 512), [
                                [_vModelText, newGateKey.value]
                              ]),
                              _createElementVNode("button", {
                                class: "btn btn-blue",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (updateKey()))
                              }, " Update "),
                              _createElementVNode("button", {
                                class: "btn btn-blue",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (editKey.value = false))
                              }, " Cancel ")
                            ]))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    _hoisted_14,
                    (customer.value)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                          _createVNode(_component_RouterLink, {
                            to: {
                  name: 'customer_detail_storedge',
                  params: { id: customer.value.id, facilityId: __props.facilityId },
                }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(customer.value.first_name) + " " + _toDisplayString(customer.value.last_name), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]),
                          _createTextVNode(" on " + _toDisplayString(unit.value.ledger.moved_in_at.split("T")[0]), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_16,
                    _createElementVNode("td", null, "$" + _toDisplayString(unit.value.ledger.current_rate) + " per month", 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_17,
                    _createElementVNode("td", null, _toDisplayString(unit.value.ledger.next_charge_date), 1)
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("tr", null, [
              _hoisted_18,
              _createElementVNode("td", null, [
                _createTextVNode(_toDisplayString(unit.value.status), 1),
                _hoisted_19,
                (selectedReservation.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_20,
                      _createVNode(_component_RouterLink, {
                        to: {
                  name: 'customer_detail_storedge',
                  params: {
                    id: selectedReservation.value.tenant
                      ? selectedReservation.value.tenant.id
                      : selectedReservation.value.customer_id,
                    facilityId: __props.facilityId,
                  },
                }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(selectedReservation.value.tenant.first_name) + " " + _toDisplayString(selectedReservation.value.tenant.last_name), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _createTextVNode(" on " + _toDisplayString(selectedReservation.value.created_at.split("T")[0]), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (unit.value.damaged)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_21
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_22,
              _createElementVNode("td", null, [
                (!unit.value.rentable)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_23
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_24
                    ], 64)),
                (!unit.value.damaged)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (unitStatusChange.value = true))
                    }, "-change status"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_25,
              _createElementVNode("td", null, _toDisplayString(unit.value.description), 1)
            ]),
            (unit.value.size)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("td", null, _toDisplayString(unit.value.size), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(isCubbyFacility))
              ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("td", null, _toDisplayString(unit.value.access_instructions), 1)
                ]))
              : _createCommentVNode("", true),
            (
            _unref(api_settings).combination_lock_number &&
            (!_unref(isCubbyFacility) || unit.value.combination_lock_number)
          )
              ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("td", null, _toDisplayString(unit.value.combination_lock_number), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          (unitStatusChange.value)
            ? (_openBlock(), _createBlock(UnitRentableModal, {
                key: 0,
                "unit-name": unit.value.name,
                "unit-status": unit.value.rentable,
                "unit-id": unit.value.id,
                "facility-id": __props.facilityId,
                onModalClosed: modalClosed
              }, null, 8, ["unit-name", "unit-status", "unit-id", "facility-id"]))
            : _createCommentVNode("", true),
          (
          customers.value &&
          (unit.value.status == 'vacant' || unit.value.status == 'available') &&
          unit.value.rentable == true
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((chosenCustomer).value = $event)),
                  class: "form-select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customers.value, (c) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: c.id + 'customer',
                      value: c.id
                    }, _toDisplayString(c.first_name) + " " + _toDisplayString(c.last_name), 9, _hoisted_33))
                  }), 128))
                ], 512), [
                  [_vModelSelect, chosenCustomer.value]
                ]),
                (chosenCustomer.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createVNode(_component_RouterLink, {
                        to: {
              name: 'rental_storedge',
              params: {
                facilityId: __props.facilityId,
                customerId: chosenCustomer.value,
                unitType: 'null',
                unitId: unit.value.id,
              },
            },
                        class: "btn"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_35
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      (_unref(api_settings).show_reservations)
                        ? (_openBlock(), _createBlock(_component_RouterLink, {
                            key: 0,
                            to: {
              name: 'reserve_unit_storedge',
              params: {
                customerId: chosenCustomer.value,
                unitId: unit.value.id,
                facilityId: __props.facilityId,
              },
            },
                            class: "btn"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_36
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _hoisted_38,
                      (_unref(api_settings).show_reservations)
                        ? (_openBlock(), _createElementBlock("button", _hoisted_39, " Reserve for Customer "))
                        : _createCommentVNode("", true)
                    ])),
                _createVNode(_component_RouterLink, {
                  to: {
            name: 'customer_storedge',
            params: {
              unitId: unit.value.id,
              facilityId: __props.facilityId,
              rental: 'false',
              customerId: null,
            },
          },
                  class: "btn"
                }, {
                  default: _withCtx(() => [
                    _hoisted_40
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (errors.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(errors.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})